module.exports = __webpack_public_path__ + "static/img/11bg_10.8c26861.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_10.png
// module id = 627
// module chunks = 1